export default __webpack_public_path__ + "static/media/spinner.66698f13.svg";